import styles from "./cluster-panel.module.css";
import { useContext } from "react";
import { GraphContext } from "./data";
import { NodeLabels } from "./node-labels";

export const ClusterPanel = () => {
  const { clusterData } = useContext(GraphContext);
  // console.log("cluster props:", clusterData);
  if (!clusterData || !clusterData["id"] || !clusterData["cluster_no"]) {
    return null;
  }

  return (
    <div className={"side-panel " + styles.panel}>
      <div className="title">{clusterData["id"]}</div>
      <div className="details">
        <NodeLabels node={clusterData} />
      </div>
    </div>
  );
};
